export default __webpack_public_path__ + "static/dolbeau-matassini-038c168f3ad9de42602a92a1164353e4.png";